const PRELOAD_RECOVERY_STORAGE_KEY = "ig:vite-preload-recovery-at";
const PRELOAD_RECOVERY_COOLDOWN_MS = 30_000;

type VitePreloadErrorEvent = Event & {
  payload?: unknown;
};

export function registerVitePreloadRecovery() {
  window.addEventListener("vite:preloadError", (event) => {
    const viteEvent = event as VitePreloadErrorEvent;
    const lastRecoveryAt = Number(
      sessionStorage.getItem(PRELOAD_RECOVERY_STORAGE_KEY) ?? 0
    );
    const now = Date.now();

    viteEvent.preventDefault();

    if (
      Number.isFinite(lastRecoveryAt) &&
      now - lastRecoveryAt < PRELOAD_RECOVERY_COOLDOWN_MS
    ) {
      console.error(
        "Skipping automatic reload after repeated Vite preload failure.",
        viteEvent.payload ?? viteEvent
      );
      return;
    }

    sessionStorage.setItem(PRELOAD_RECOVERY_STORAGE_KEY, `${now}`);
    window.location.reload();
  });
}
